import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    class: "sticky-top-20",
    style: { "padding-top": "5px" }
};
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("h5", {
    class: "title ps-2",
    style: { "padding-left": "16px" }
}, "Belege suchen", -1);
const _hoisted_3 = { class: "container ps-2 pe-3" };
const _hoisted_4 = { class: "row" };
const _hoisted_5 = { class: "col" };
const _hoisted_6 = { class: "row" };
const _hoisted_7 = { class: "col" };
const _hoisted_8 = { class: "row" };
const _hoisted_9 = { class: "col" };
const _hoisted_10 = { class: "row" };
const _hoisted_11 = { class: "col" };
const _hoisted_12 = { class: "row" };
const _hoisted_13 = { class: "col-12 col-xl-6" };
const _hoisted_14 = { class: "col-12 col-xl-6" };
const _hoisted_15 = { class: "row mt-1" };
const _hoisted_16 = { class: "col" };
const _hoisted_17 = { class: "container" };
const _hoisted_18 = { class: "table table-hover border-top-0 mb-0" };
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", { class: "font-weight-bold" }, [
        /*#__PURE__*/ _createElementVNode("td", { class: "border-top-0 col-1 fw-bold text-center" }, "Nummer"),
        /*#__PURE__*/ _createElementVNode("td", { class: "border-top-0 col-4" }, "Name"),
        /*#__PURE__*/ _createElementVNode("td", { class: "border-top-0 col-5" }, "Kommission / Ext. Nummer"),
        /*#__PURE__*/ _createElementVNode("td", { class: "border-top-0 col-2 text-end" }, "Betrag in EUR"),
        /*#__PURE__*/ _createElementVNode("td", { class: "border-top-0 col-2 text-center text-nowrap" }, "Datum / Status")
    ])
], -1);
const _hoisted_20 = { class: "text-center" };
const _hoisted_21 = { class: "fw-bold" };
const _hoisted_22 = ["onClick"];
const _hoisted_23 = { class: "fst-italic" };
const _hoisted_24 = { class: "text-end fw-bold" };
const _hoisted_25 = { class: "text-center text-nowrap" };
const _hoisted_26 = { key: 0 };
const _hoisted_27 = { class: "fst-italic" };
const _hoisted_28 = { key: 1 };
const _hoisted_29 = {
    key: 0,
    class: "container-sm bg-light pt-3 pb-3 border-bottom border-start border-end"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_portal = _resolveComponent("portal");
    const _component_g_breadcrumb = _resolveComponent("g-breadcrumb");
    const _component_g_select_field = _resolveComponent("g-select-field");
    const _component_g_text_field = _resolveComponent("g-text-field");
    const _component_g_date_edit = _resolveComponent("g-date-edit");
    const _component_g_button = _resolveComponent("g-button");
    const _component_g_form = _resolveComponent("g-form");
    const _component_g_pager = _resolveComponent("g-pager");
    const _component_g_content_page = _resolveComponent("g-content-page");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_portal, {
            to: "command-bar",
            order: 900
        }, {
            default: _withCtx(() => [
                _createElementVNode("div", null, [
                    _createElementVNode("a", {
                        href: "#",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.OnRefresh($event)))
                    }, "Aktualisieren")
                ])
            ]),
            _: 1
        }),
        _createVNode(_component_g_content_page, null, {
            title: _withCtx(() => [
                _createVNode(_component_g_breadcrumb)
            ]),
            sidebar: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                    _hoisted_2,
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_g_form, {
                            ref: "frmMain",
                            "data-object": _ctx.filter
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("div", _hoisted_5, [
                                        _createVNode(_component_g_select_field, {
                                            label: "Belegart",
                                            "data-member": "type",
                                            itemSource: [{ name: 'carts', caption: 'Web-Belege' }],
                                            valueExpr: "name",
                                            displayExpr: "caption"
                                        })
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("div", _hoisted_7, [
                                        _createVNode(_component_g_text_field, {
                                            label: "Nummer",
                                            "data-member": "ordernumber"
                                        })
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("div", _hoisted_9, [
                                        _createVNode(_component_g_text_field, {
                                            label: "Name",
                                            "data-member": "name"
                                        })
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("div", _hoisted_11, [
                                        _createVNode(_component_g_text_field, {
                                            label: "Kommission / Ext. Nummer",
                                            "data-member": "reference"
                                        })
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_12, [
                                    _createElementVNode("div", _hoisted_13, [
                                        _createVNode(_component_g_date_edit, {
                                            label: "Belegdatum",
                                            "data-member": "datefrom"
                                        })
                                    ]),
                                    _createElementVNode("div", _hoisted_14, [
                                        _createVNode(_component_g_date_edit, {
                                            label: "bis",
                                            "data-member": "dateto"
                                        })
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_15, [
                                    _createElementVNode("div", _hoisted_16, [
                                        _createVNode(_component_g_button, {
                                            text: "Suchen",
                                            onClick: _withModifiers(_ctx.OnSearch, ["stop", "prevent"]),
                                            "is-loading": _ctx.isWorking
                                        }, null, 8, ["onClick", "is-loading"])
                                    ])
                                ])
                            ]),
                            _: 1
                        }, 8, ["data-object"])
                    ])
                ])
            ]),
            content: _withCtx(() => [
                _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("table", _hoisted_18, [
                        _hoisted_19,
                        _createElementVNode("tbody", null, [
                            (_ctx.documents.records && _ctx.documents.records.length > 0)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.documents.records, (document) => {
                                    return (_openBlock(), _createElementBlock("tr", null, [
                                        _createElementVNode("td", _hoisted_20, [
                                            _createElementVNode("div", _hoisted_21, [
                                                _createElementVNode("a", {
                                                    href: "#",
                                                    onClick: _withModifiers(($event) => (_ctx.showDetails(document.documentID)), ["stop", "prevent"])
                                                }, _toDisplayString(document.number), 9, _hoisted_22)
                                            ]),
                                            _createElementVNode("div", _hoisted_23, _toDisplayString(document.typeCaption), 1)
                                        ]),
                                        _createElementVNode("td", null, _toDisplayString(document.name), 1),
                                        _createElementVNode("td", null, _toDisplayString(document.referenceNumbers), 1),
                                        _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.$utils.formatNumberWithDcp(document.totalNetAmount, 2)), 1),
                                        _createElementVNode("td", _hoisted_25, [
                                            (document.timestamp)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_ctx.$utils.formatDate(Date.parse(document.timestamp), 'date-shorttime')), 1))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("div", _hoisted_27, [
                                                (document.stateColor)
                                                    ? (_openBlock(), _createElementBlock("span", {
                                                        key: 0,
                                                        class: _normalizeClass(["badge", document.stateColor])
                                                    }, _toDisplayString(document.stateCaption), 3))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(document.stateCaption), 1))
                                            ])
                                        ])
                                    ]));
                                }), 256))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    (_ctx.documents.recordCount > _ctx.documents.pageSize)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            _createVNode(_component_g_pager, {
                                page: parseInt(_ctx.$route?.query?.p ?? 1),
                                records: _ctx.documents.recordCount,
                                "page-size": _ctx.documents.pageSize
                            }, null, 8, ["page", "records", "page-size"])
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]),
            _: 1
        })
    ], 64));
}
